import { motion } from "framer-motion";

export function WelcomeHeader({ displayName, status, lastUpdated }) {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="mb-10" data-testid="welcome-header">
      <h1 className="font-serif text-4xl text-igc-cream tracking-tight">Welcome, {displayName}</h1>
      <div className="flex items-center gap-6 mt-3 text-sm">
        <span className="flex items-center gap-2 text-igc-muted">
          Store Status:
          <span className={`px-3 py-1 text-xs tracking-wide ${status === "Active" ? "bg-igc-success/10 text-igc-success" : "bg-igc-gold/10 text-igc-goldText"}`} data-testid="store-status-badge" title="Whether your store is currently live and taking orders.">
            {status}
          </span>
        </span>
        <span className="text-igc-muted" data-testid="last-updated-label" title="The last time your dashboard numbers were refreshed with approved data.">Last Updated: {lastUpdated}</span>
      </div>
    </motion.div>
  );
}
